import React, { useEffect } from "react";
import { Outlet, Link } from "react-router-dom";
import trim1 from "../../assets/firstt.png";
import trim2 from "../../assets/secondt.png";
import trim3 from "../../assets/thirdt.png";
import trim4 from "../../assets/beforet.png";
import trim5 from "../../assets/aftert.png";

import "./tools.css";
import { Helmet } from "react-helmet";
import { use } from "react";

function Trim({ selectedTool, setSelectedTool }) {
  useEffect(() => {
    setSelectedTool("/checklist");
  }, []);
  
  return (
    <div className="trim" style={{ background: "#B24C76" }}>
      <Helmet>
        <title>Pregnancy Trimester Checklist - Key Steps for Each Stage!</title>
        <meta
          name="description"
          content="Check out this essential trimester checklist. From the first to the third trimesters. Milestones to keep you organised and prepared for a healthy pregnancy."
        />
        <meta
          name="keywords"
          content="First, second , Third trimester checklist, pregnancy checklist"
        />
      </Helmet>
      <div className="trim-white">
        <div className="bread-container">
          <nav aria-label="breadcrumb">
            <ol className="crumb">
              <li className="breadcrumblist">
                <Link
                  to="/"
                  className="breadcrumb-link"
                  onClick={() => setSelectedTool("")}
                >
                  Home
                </Link>
              </li>
              <li className="breadcrumblist">
                <Link to="/tools" className="breadcrumb-link">
                  Tools
                </Link>
              </li>
              <li className="breadcrumblist active">Trimester</li>
            </ol>
          </nav>
        </div>
        <h1
          className="trim-header"
          style={{ textTransform: "initial", textAlign: "center" }}
        >
          Trimester Checklist
        </h1>

        <div className="tri-list">
          <Link
            to="trimester-1"
            className="animated-link"
            style={{ backgroundColor: "#FDE1EC" }}
            id="tri-1"
          >
            <img src={trim1} alt="trimster3" />
          </Link>
          <Link
            to="trimester-2"
            className="animated-link"
            style={{ backgroundColor: "#EEECFF" }}
            id="tri-1"
          >
            <img src={trim2} alt="trimster2" />
          </Link>
          <Link
            to="trimester-3"
            className="animated-link"
            style={{ backgroundColor: "#EEDBEF" }}
            id="tri-1"
          >
            <img src={trim3} alt="trimster3" />
          </Link>
          <Link
            to="before-delivery"
            className="animated-link"
            style={{ backgroundColor: "#EEFFEA" }}
            id="tri-1"
          >
            <img src={trim4} alt="trimster4" />
          </Link>
          <Link
            to="after-delivery"
            className="animated-link"
            style={{ backgroundColor: "#D3DCEA" }}
            id="tri-1"
          >
            <img src={trim5} alt="trimster5" />
          </Link>
        </div>

        <Outlet />
      </div>
    </div>
  );
}

export default Trim;
